<template>
  <button
    type="button"
    class="select-none inline-flex items-center px-3 py-1 border border-gray-200 bg-gray-25 text-gray-800 text-xs font-medium cursor-pointer hover:bg-gray-100 transition-colors"
    @click.stop="onRemove"
  >
    {{ prettyName }}: {{ value }}
    <span
      class="ml-2 text-lg leading-none text-red-600 hover:text-red-500 cursor-pointer"
    >×</span>
  </button>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = defineProps<{
  facet: string
  value: string
}>()

const emit = defineEmits<{
  (e: 'remove'): void
}>()

const facetDisplayNames: Record<string, string> = {
  AssetTypeName: 'Asset Type',
  sei_year_published: 'Year Published',
  sei_topic: 'Topic',
  sei_author: 'Author',
}

const prettyName = computed(() => facetDisplayNames[props.facet] || props.facet)

function onRemove() {
  emit('remove')
}
</script>
